import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=0739f23c"
import script from "./leader-board.ts?vue&type=script&lang=ts&external"
export * from "./leader-board.ts?vue&type=script&lang=ts&external"
import style0 from "./leader-board.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports